import React, { useState } from 'react';
import Svg from '@justgiving/svg';
import linkIcon from '@justgiving/icons/lib/link.svg';
import classNames from 'classnames';

import styles from '../SocialButtons/SocialButtonsList.scss';
import IconButton from '../IconButton/IconButton';
import { useShareContext } from '../../context/ShareContext';

export interface CopyLinkProps {
  onClick?: () => void;
}

export const CopyLinkShareButton: React.FunctionComponent<CopyLinkProps> = ({
  onClick = () => {},
}) => {
  const [buttonText, setButtonText] = useState('Copy link');
  const { shareItems } = useShareContext();

  async function onCopy() {
    onClick();
    try {
      await navigator.clipboard.writeText(shareItems.copyLink.url);
      setButtonText('Copied');
    } catch (e) {
      setButtonText('Copy failed');
    }

    setTimeout(() => {
      setButtonText('Copy link');
    }, 3000);
  }

  return (
    <IconButton className={styles.copy} onClick={() => onCopy()}>
      <div>
        <Svg className={classNames(styles.icon)} markup={linkIcon} />
      </div>
      <div className={styles.url}>{shareItems.copyLink.url}</div>
      <span className={styles.copyButtonText}>{buttonText}</span>
    </IconButton>
  );
};
